







































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Category from "@/store/entities/category";
import MediaBox from "@/components/media/media-box.vue";
import { EventBus } from "@/lib/eventbus";
import Editor from "@tinymce/tinymce-vue";
import MediaPicker from '@/components/media/media-picker.vue'
import simplifyString from "simplify-string";
import PageRequest from '@/store/entities/page-request';

class CardsPageRequest extends PageRequest {
  categoryId: number;
}

@Component({
  components: { MediaBox, editor: Editor, MediaPicker },
})
export default class EditPost extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  $refs!: {
    editor: any;
    form: any;
    tiny: any;
  };

  spinShow: boolean = true;
  category: Category = new Category();
  callbackVar = null;
  pagerequest: CardsPageRequest = new CardsPageRequest();
  @Watch("category.name")
  oncategoryNamechanged(val: string, oldVal: string) {
    if (val == undefined) {
      return false;
    }
    this.category.simpleCategoryName = simplifyString(val);
  }
  get list() {
    return this.$store.state.post.list;
  };
  get loading() {
    return this.$store.state.post.loading;
  }
  get mediaPickerShow() {
    return this.$store.state.mediapicker.show;
  }
  set mediaPickerShow(value) {
    this.$store.commit("mediapicker/setShow", value);
  }
  get pageSize() {
    return this.$store.state.post.pageSize;
  }
  get totalCount() {
    return this.$store.state.post.totalCount;
  }
  get currentPage() {
    return this.$store.state.post.currentPage;
  }
  pageChange(page: number) {
    this.$store.commit('post/setCurrentPage', page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit('post/setPageSize', pagesize);
    this.getpage();
  }
  async edit(row) {
    const postId = row.id;
    this.$router.push({ name: 'post', params: { postId } })
  }
  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let category = this.category;
        this.spinShow = true;
        if (this.category.id > 0) {
          await this.$store
            .dispatch({
              type: "category/update",
              data: this.category,
            })
            .then(() => {
              (this.$refs.form as any).resetFields();
              this.$router.push({ name: "categories" });
            });
        } else {
          await this.$store
            .dispatch({
              type: "category/create",
              data: this.category,
            })
            .then(() => {
              (this.$refs.form as any).resetFields();
              this.$router.push({ name: "categories" });
            });
        }
      }
    });
  }
  cancel() {
    this.$router.push({ name: "categories" });
  }
  imageRecived(mediaitem) {
    this.category.imageUrl = mediaitem.fileWebPath;
    this.category.imageId = mediaitem.id;

  }
  async getpage() {
    var categoryId = this.$route.params.categoryId;

    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.categoryId = parseInt(categoryId);
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: 'post/getAllByCategory',
      data: this.pagerequest
    })


    if (parseInt(categoryId) > 0) {
      await this.$store
        .dispatch({
          type: "category/get",
          data: { Id: categoryId },
        })
        .then((result) => {
          this.category = result;
          this.spinShow = false;
        });
    } else {
      this.spinShow = false;
    }
  }
  async created() {
    this.getpage();
  }
  mounted() {
    this.getpage();
    EventBus.$on("sendImageForBoxImage", (mediaItem) => {
      this.imageRecived(mediaItem);
    });
  }
  columns = [{
    title: this.L('Title'),
    key: 'title'
  },
  {
    title: this.L('Order'),
    key: 'order',
    wdith: 80
  }
    , {
    title: this.L('Actions'),
    key: 'Actions',
    width: 80,
    render: (h: any, params: any) => {
      return h('ButtonGroup', { props: { vertical: '' } }, [
        h('Button', {
          props: {
            type: 'primary',
            icon: 'md-arrow-up',
            ghost: '',
          },
          ghost: '',
          on: {
            click: async () => {
              await this.$store.dispatch({
                type: 'post/up',
                data: params.row
              }).then(async () => {
                await this.getpage();
              })
            }
          }
        },),
        h('Button', {
          props: {
            type: 'primary',
            size: 'small',
            icon: 'md-create'
          },
          style: {
            // marginRight:'5px'
          },
          on: {
            click: () => {
              this.edit(params.row);
            }
          }
        }),
        h('Button', {
          props: {
            type: 'error',
            icon: 'md-trash',
            size: 'small',
            ghost: '',
          },
          ghost: '',
          on: {
            click: async () => {
              this.$Modal.confirm({
                title: this.L('Tips'),
                content: this.L('DeleteMediaConfirm'),
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                  await this.$store.dispatch({
                    type: 'post/delete',
                    data: params.row
                  })
                  await this.getpage();
                }
              })
            }
          }
        },),
        h('Button', {
          props: {
            type: 'primary',
            icon: 'md-arrow-down',
            ghost: '',
          },
          ghost: '',
          on: {
            click: async () => {
              await this.$store.dispatch({
                type: 'post/down',
                data: params.row
              }).then(async () => {
                await this.getpage();
              })
            }
          }
        },)
      ])
    }
  }]
  rules = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name2")),
        trigger: "blur",
      },
    ],
  };
}
